import React from "react";
import {Button, Form, FormField, Grid, Segment} from "semantic-ui-react";
import store from "./XmlGenerationDebugStore";
import {observer} from "mobx-react-lite";

function XmlGenerationDebugBlock() {
    if (!store.visible) {
        return <></>
    }

    return <Grid>
        <Grid.Column width={'7'}>
            <Segment>
                <Form>
                    <FormField>
                        <label>UserId</label>
                        <input value={store.userId}
                               onChange={e => store.setUserId(e.target.value)}/>
                    </FormField>
                    <Button disabled={!store.canCreate} onClick={() => store.create()} color={'teal'}>Создать</Button>
                    <Button floated={'right'} onClick={() => store.hide()}>Закрыть</Button>
                </Form>
            </Segment>
        </Grid.Column>
    </Grid>
}

export default observer(XmlGenerationDebugBlock);